/**
 * Compact duration for hour-scale values: `52m`, `7h 43m`, `25h`. (QC's `formatDurationSeconds`
 * is `m:ss`, which suits call lengths but not case clocks of many hours.)
 */
export const formatDurationHm = (seconds: number | undefined): string => {
  if (seconds == null || !Number.isFinite(seconds) || seconds < 0) return '—';
  const totalMinutes = Math.round(seconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours === 0) return `${minutes}m`;
  return minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`;
};

/** `formatDurationHm` with an explicit sign: `+1h 5m`, `-5m`, `0m`. */
export const formatSignedDurationHm = (seconds: number | undefined): string => {
  if (seconds == null || !Number.isFinite(seconds)) return '—';
  const body = formatDurationHm(Math.abs(seconds));
  if (body === '0m') return body;
  return `${seconds > 0 ? '+' : '-'}${body}`;
};
